import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownOutlined } from "@ant-design/icons";
import { App, Dropdown, Space } from "antd";
import { useCallback } from "react";
import { TemplateCenterCards } from "../templateCenter";
import { useI18n } from "../../contexts";
const ScannerCards = (param)=>{
    let { templates, onSelect, dropdownItems = ()=>[], isTcf, onIgnoreToggle } = param;
    const { modal } = App.useApp();
    const { __ } = useI18n();
    const handleAcknowledgementClick = useCallback((action, template)=>{
        if (action === "ignore") {
            onIgnoreToggle(template, true);
        }
    }, [
        onIgnoreToggle
    ]);
    const handleSelect = useCallback((template)=>{
        const { tcfVendorIds, name, consumerData: { createAdNetwork } } = template;
        const isTcfTemplate = (tcfVendorIds == null ? void 0 : tcfVendorIds.length) > 0 && !isTcf;
        if (isTcfTemplate) {
            window.location.href = `#/settings/tcf?tcfIntegrationItem=${encodeURIComponent(name)}&navigateAfterTcfActivation=${encodeURIComponent(createAdNetwork ? `#/cookies/tcf-vendors/new?adNetwork=${encodeURIComponent(createAdNetwork)}` : "#/scanner")}`;
        } else {
            onSelect(template);
        }
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ _jsx(TemplateCenterCards, {
        showHidden: true,
        grayOutAlreadyExisting: true,
        templates: templates,
        onSelect: handleSelect,
        onAcknowledgementClick: handleAcknowledgementClick,
        renderTags: useCallback((tags, template)=>{
            const { isIgnored, acknowledgement } = template.consumerData;
            if (isIgnored) {
                tags[acknowledgement ? __("Acknowledged") : __("Ignored")] = "";
            }
            return tags;
        }, []),
        renderActions: useCallback((template, delegateSelect)=>{
            const { tcfVendorIds, consumerData: { isDisabled, isIgnored, acknowledgement } } = template;
            const isTcfTemplate = (tcfVendorIds == null ? void 0 : tcfVendorIds.length) > 0 && !isTcf;
            const createNowLabel = acknowledgement ? __("Show explanation") : isTcfTemplate ? __("Activate TCF") : __("Create now");
            const ignoreLabel = isIgnored ? __("Show recommendation again") : acknowledgement ? __("Acknowledge recommendation") : __("Ignore recommendation");
            return [
                !isDisabled && /*#__PURE__*/ _jsx(Dropdown, {
                    menu: {
                        items: [
                            {
                                key: "create",
                                label: /*#__PURE__*/ _jsx("a", {
                                    className: "rcb-template-card-create-link",
                                    children: createNowLabel
                                })
                            },
                            ...dropdownItems(template, delegateSelect),
                            !template.consumerData.isCreated && {
                                key: "ignore",
                                label: /*#__PURE__*/ _jsx("a", {
                                    onClick: ()=>{
                                        const handleToggle = ()=>onIgnoreToggle(template, !isIgnored);
                                        if (isIgnored || acknowledgement) {
                                            handleToggle();
                                        } else {
                                            modal.confirm({
                                                title: __("Are you sure that you want to ignore this recommendation?"),
                                                onOk: handleToggle,
                                                okText: __("Ignore recommendation"),
                                                cancelText: __("Cancel")
                                            });
                                        }
                                    },
                                    children: ignoreLabel
                                })
                            }
                        ].filter(Boolean)
                    },
                    children: /*#__PURE__*/ _jsxs(Space, {
                        children: [
                            createNowLabel,
                            /*#__PURE__*/ _jsx(DownOutlined, {})
                        ]
                    })
                }, "dropdown")
            ].filter(Boolean);
        }, [])
    });
};
export { ScannerCards };
